import { ACTIONS_TYPES } from "../utils/constants";




export function fetchUsersRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_USERS_REQUEST,
  }
}

export function fetchUsersSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_USERS_SUCCESS,
    payload: response,
  }
}

export function fetchUsersFailed(error) {
  return {
    type: ACTIONS_TYPES.FETCH_USERS_FAILED,
    payload: error,
  }
}

export function fetchUsersReset() {
  return {
    type: ACTIONS_TYPES.FETCH_USERS_RESET,
  }
}

export function SuspendUserReset() {
  return {
    type: ACTIONS_TYPES.SUSPEND_USER_RESET,
  }
}

export function suspendUserRequest(payload) {
  return {
    type: ACTIONS_TYPES.SUSPEND_USER_REQUEST,
    payload
  }
}

export function suspendUserSuccess(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_USER_SUCCESS,
    payload: response,
  }
}

export function suspendUserFailed(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_USER_FAILED,
    payload: response,
  }
}

